/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../Fixes';
import Builder from '../../../../Builder';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "cash": {
        "nested": {
          "cashidv": {
            "nested": {
              "common": {
                "nested": {
                  "Name": {
                    "fields": {
                      "fullName": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "firstName": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      },
                      "middleName": {
                        "type": "string",
                        "id": 3,
                        "rule": "optional"
                      },
                      "lastName": {
                        "type": "string",
                        "id": 4,
                        "rule": "optional"
                      },
                      "suffix": {
                        "type": "string",
                        "id": 5,
                        "rule": "optional"
                      }
                    }
                  },
                  "BirthDate": {
                    "fields": {
                      "day": {
                        "type": "int32",
                        "id": 1,
                        "rule": "optional"
                      },
                      "month": {
                        "type": "int32",
                        "id": 2,
                        "rule": "optional"
                      },
                      "year": {
                        "type": "int32",
                        "id": 3,
                        "rule": "optional"
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.cash?.nested?.cashidv?.nested?.common?.nested?.Name && !$root.nested?.squareup?.nested?.cash?.nested?.cashidv?.nested?.common?.nested?.BirthDate) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE Name @ squareup/cash/cashidv/common/Identity.proto at 10:1
 */
export const Name = $root.lookupType('squareup.cash.cashidv.common.Name');
fixType(Name);
Builder.createAndAttachToType(Name);
/**
 * SOURCE BirthDate @ squareup/cash/cashidv/common/Identity.proto at 18:1
 */
export const BirthDate = $root.lookupType('squareup.cash.cashidv.common.BirthDate');
fixType(BirthDate);
Builder.createAndAttachToType(BirthDate);